import { Text } from '@betterment/style-closet-react';

const Title: React.FC<{ title?: string; color?: string; strong?: boolean }> = ({ title, color, strong }) => (
  <Text color={color} fontSize={1} as={strong ? 'strong' : 'span'}>
    {title}
  </Text>
);

export default Title;
